module.exports = __webpack_public_path__ + "static/media/hero-image-1.617dd4e3.png";